import { CellPlugin } from '@react-page/editor';
import SiteMaintenanceBanner, {
    BANNER_BACKGROUND_COLOR,
    BANNER_FONT_SIZE,
    BANNER_FONT_WEIGHT,
    BANNER_MESSAGE,
    BANNER_PADDING,
    BANNER_TEXT_ALIGN,
    BANNER_TEXT_COLOR,
    DISABLE_BUTTONS,
    DISABLE_NAV_LINKS,
    DISABLED_TOOLTIP,
    END_DATE_TIME,
    IS_ENABLED,
    SELECTED_TIMEZONE,
    START_DATE_TIME,
    coerceBool,
} from './components/SiteMaintenanceBanner';

type Data = {
    isEnabled: boolean;
    bannerMessage: string;
    bannerBackgroundColor: string;
    bannerTextColor: string;
    bannerFontSize: string;
    bannerFontWeight: string;
    bannerTextAlign: string;
    bannerPadding: string;
    startDateTime: string;
    endDateTime: string;
    selectedTimezone: string;
    disableButtons: boolean;
    disableNavLinks: boolean;
    disabledTooltip: string;
};

const resolve = (data: Partial<Data>): Data => ({
    isEnabled: coerceBool(data.isEnabled, IS_ENABLED),
    bannerMessage: data.bannerMessage ?? BANNER_MESSAGE,
    bannerBackgroundColor: data.bannerBackgroundColor ?? BANNER_BACKGROUND_COLOR,
    bannerTextColor: data.bannerTextColor ?? BANNER_TEXT_COLOR,
    bannerFontSize: data.bannerFontSize ?? BANNER_FONT_SIZE,
    bannerFontWeight: data.bannerFontWeight ?? BANNER_FONT_WEIGHT,
    bannerTextAlign: data.bannerTextAlign ?? BANNER_TEXT_ALIGN,
    bannerPadding: data.bannerPadding ?? BANNER_PADDING,
    startDateTime: data.startDateTime ?? START_DATE_TIME,
    endDateTime: data.endDateTime ?? END_DATE_TIME,
    selectedTimezone: data.selectedTimezone ?? SELECTED_TIMEZONE,
    disableButtons: coerceBool(data.disableButtons, DISABLE_BUTTONS),
    disableNavLinks: coerceBool(data.disableNavLinks, DISABLE_NAV_LINKS),
    disabledTooltip: data.disabledTooltip ?? DISABLED_TOOLTIP,
});

const SiteMaintenanceBannerPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => (
        <SiteMaintenanceBanner {...resolve(data)} />
    ),
    id: 'siteMaintenanceBannerPlugin',
    title: 'Site Maintenance Banner',
    description: 'Renders the maintenance banner configured in the CMS.',
    version: 1,
    controls: [],
};

export default SiteMaintenanceBannerPlugin;